import { Link } from "react-router-dom";
import {
  Briefcase,
  PieChart,
  Landmark,
  Rocket,
  Gem,
  Cpu,
  Building2,
  Shield,
  ArrowUpRight,
} from "lucide-react";
import useReveal from "../shared/useReveal";
import "./ProductCards.css";
import "./HomeSections.css";

const PRODUCTS = [
  {
    icon: Briefcase,
    title: "Portfolio Management",
    desc: "Research-driven portfolios, reviewed quarterly against your goals.",
    href: "/portfolio-review",
    cta: "Explore",
    featured: true,
    accent: "mint",
  },
  {
    icon: PieChart,
    title: "Mutual Funds",
    desc: "Goal-based SIP & lumpsum plans with fund selection and rebalancing.",
    href: "/mutual-funds",
    cta: "Start SIP",
    featured: true,
    accent: "gold",
  },
  {
    icon: Landmark,
    title: "Bonds",
    desc: "G-Secs, corporate, tax-free & SGBs — always quoted at true YTM.",
    href: "/bonds",
    cta: "See yields",
  },
  {
    icon: Rocket,
    title: "IPO Advisory",
    desc: "Analysis, GMP tracking and honest Apply / Avoid calls.",
    href: "/ipo-advisory",
    cta: "IPO alerts",
  },
  {
    icon: Gem,
    title: "Unlisted Shares",
    desc: "Researched pre-IPO opportunities with exit plans and paperwork.",
    href: "/unlisted-shares",
    cta: "View deals",
  },
  {
    icon: Cpu,
    title: "Algo Trading",
    desc: "Rule-based, back-tested strategies — white-label for brokers too.",
    href: "/algo-trading",
    cta: "Strategies",
  },
  {
    icon: Building2,
    title: "Business Finance",
    desc: "Loans, funding, incorporation, tax & subsidies — ₹200 Cr+ raised.",
    href: "/business-services",
    cta: "For business",
  },
  {
    icon: Shield,
    title: "Insurance",
    desc: "Health & life cover compared across insurers, with claim support.",
    href: "/insurance",
    cta: "Get protected",
  },
];

export default function ProductCards() {
  const ref = useReveal();
  const featured = PRODUCTS.filter((p) => p.featured);
  const rest = PRODUCTS.filter((p) => !p.featured);

  return (
    <section className="section" id="invest">
      <div className="container" ref={ref}>
        <div className="home-section-head section-head pm-reveal">
          {/* <span className="kicker">All Things Finance</span> */}
          <h2>Everything in finance. Under one roof.</h2>
          <p className="sub">
            Pick a product — an expert (not an algorithm) helps you get it right.
          </p>
        </div>

        <div className="home-prod-bento pm-stagger">
          <div className="home-prod-featured">
            {featured.map(({ icon: Icon, title, desc, href, cta, accent }) => (
              <Link
                key={title}
                to={href}
                className={`home-pcard home-pcard--featured home-pcard--${accent} pm-reveal`}
              >
                <div className="home-pcard-top">
                  <div className="pi">
                    <Icon size={24} strokeWidth={2} />
                  </div>
                  <span className="go">
                    {cta}
                    <ArrowUpRight size={16} />
                  </span>
                </div>
                <h3>{title}</h3>
                <p>{desc}</p>
              </Link>
            ))}
          </div>

          <div className="home-prod-grid">
            {rest.map(({ icon: Icon, title, desc, href, cta }) => (
              <Link key={title} to={href} className="home-pcard home-pcard--row pm-reveal">
                <div className="pi">
                  <Icon size={20} strokeWidth={2} />
                </div>
                <div className="home-pcard-body">
                  <h3>{title}</h3>
                  <p>{desc}</p>
                </div>
                <span className="go">
                  {cta}
                  <ArrowUpRight size={14} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
